import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const IMAGES = [
  "https://images.pexels.com/photos/23696832/pexels-photo-23696832.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/13827306/pexels-photo-13827306.jpeg",
  "https://images.pexels.com/photos/12950219/pexels-photo-12950219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1651319484670-aaed6d6726cb",
  "https://images.unsplash.com/photo-1642870776984-f808ed7acc14",
  "https://images.pexels.com/photos/37949153/pexels-photo-37949153.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1566323124508-c708b5524d61",
  "https://images.pexels.com/photos/570031/pexels-photo-570031.jpeg",
  "https://images.pexels.com/photos/1603650/pexels-photo-1603650.jpeg",
  "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23",
  "https://images.unsplash.com/photo-1544986581-efac024faf62",
  "https://images.pexels.com/photos/34053333/pexels-photo-34053333.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export default function GalleryPage() {
  const [imgs, setImgs] = useState([]);
  useEffect(() => {
    api.get("/packages").then(r => {
      const all = new Set([...IMAGES]);
      r.data.packages.forEach(p => { p.gallery?.forEach(g => all.add(g)); all.add(p.image); });
      setImgs([...all]);
    });
  }, []);
  return (
    <div className="pt-32 pb-24 bg-white dark:bg-slate-950">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] font-semibold">Gallery</div>
          <h1 className="mt-3 text-5xl font-bold text-blue-950 dark:text-white">Moments, framed.</h1>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {imgs.map((src, i) => (
            <div key={i} data-testid={`gallery-item-${i}`}
              className={`rounded-2xl overflow-hidden ${i % 5 === 0 ? "row-span-2" : ""}`}>
              <img loading="lazy" src={src} alt="" className="w-full h-full object-cover hover:scale-105" style={{transition:"transform 1s ease", minHeight: i%5===0?"400px":"180px"}}/>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
